const FETCH_CHILD_PLANS_PATH = (childId) => `/child/${childId}/getPlans/`;
const CREATE_PLAN_PATH = '/plan/';
const EDIT_PLAN_PATH = (planId) => `/plan/${planId}/`;
const FETCH_REMEMBER_OPTIONS_PLAN_PATH = '/plan/getOptions/';

const CHILD_CHECKLIST_PATH = (childId) => `/child/${childId}/getChecklists/`;
const CHECKLIST_CREATION_PATH = `/checklist/`;
const CHILD_CHECKLIST_DATES = (childId) => `/child/${childId}/getChecklistsDates/`;
const CREATE_CRITERION_PATH = '/checklist/createCriteria/';
const CHECKLIST_ITEM_PATH = (itemId) => `/checklistItem/${itemId}/`;
const CHILD_CHECKLIST_VALUATE_PATH = '/checklist/childValuate/';
const CRITERION_TAGS_LIST = '/checklist/tags/';
const PARENT_CHECKLIST_VALUATE_PATH = '/checklist/parentValuate/';
const UPDATE_CRITERIA_PATH = (itemId) => `/checklistItem/${itemId}/update_criteria/`;
const ACCEPT_OR_REJECT_CHECKLIST = (id) => `/checklist/${id}/parentItemValuate/`;
const CHANGE_ITEM_ORDER = (childId) => `/child/${childId}/change_index/`

export default {
  //Plans
  FETCH_CHILD_PLANS_PATH,
  CREATE_PLAN_PATH,
  EDIT_PLAN_PATH,
  FETCH_REMEMBER_OPTIONS_PLAN_PATH,

  //Checklist
  CHILD_CHECKLIST_PATH,
  CHECKLIST_CREATION_PATH,
  CHILD_CHECKLIST_DATES,
  CREATE_CRITERION_PATH,
  CHECKLIST_ITEM_PATH,
  CHILD_CHECKLIST_VALUATE_PATH,
  CRITERION_TAGS_LIST,
  UPDATE_CRITERIA_PATH,
  PARENT_CHECKLIST_VALUATE_PATH,
  ACCEPT_OR_REJECT_CHECKLIST,
  CHANGE_ITEM_ORDER
};

